import { Component, OnInit, Signal, signal } from '@angular/core';
import { ActivatedRoute, Data, Router, RouterLink } from '@angular/router';
import { PermissionService } from '../../modules/buildings-shared/services/permission.service';

@Component({
  selector: 'app-register-complete',
  imports: [RouterLink,],
  templateUrl: './register-complete.component.html',
  styleUrl: './register-complete.component.scss'
})
export class RegisterCompleteComponent implements OnInit {

    registrationResult = signal<boolean | undefined>(undefined);
    userNickname = signal<string | undefined>(undefined);
    sendingMailSuspended = signal<boolean>(false);

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private permissionService: PermissionService) { }

    ngOnInit(): void {
        this.permissionService.setWaitingSpinner(true);
        this.sendingMailSuspended.set(true);
        this.activatedRoute.params.subscribe( (params) => {
            this.registrationResult.set(params['success']);
            this.userNickname.set(params['nickname']);
            this.permissionService.setWaitingSpinner(false);
            setTimeout( () => this.sendingMailSuspended.set(false), 10000);
        });
    }

    sendNewEmail() {
        this.permissionService.setWaitingSpinner(true);
        if (this.userNickname() && !this.sendingMailSuspended()) {
            let modalMessage: string = "";
            this.permissionService.sendRegistrationConfirmMail(this.userNickname() as string).then( (result: any) => {
                console.log(result);
                modalMessage = (result && result.length > 0) ? ("Abbiamo inviato una nuova mail all'indirizzo di posta \"" + result + "\".") : "Non è stato possibile inviare nuovamente la mail: riprova più tardi." 
            }).catch((error: any) => {
                console.error("RegisterCompleteComponent.sendNewMail() - An error occurred. ERROR: " + JSON.stringify(error));
                modalMessage =  "Non è stato possibile inviare nuovamente la mail: riprova più tardi.";
            }).finally(() => {
                this.permissionService.setWaitingSpinner(false);
                this.permissionService.alert( modalMessage ).then( () => {
                    this.sendingMailSuspended.set(true);
                    setTimeout( () => this.sendingMailSuspended.set(false), 1000);
                });
            });
        } else {
            this.permissionService.setWaitingSpinner(false);
        }
    }
}